import api from '../index'

const { http, index, simpleSearch } = api

/**
 * ===================
 * Master Lists API
 * ===================
 */

export const skill = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'skills',
  http,
  index
}

export const skillCategory = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'skill-categories',
  http,
  index,
  simpleSearch
}

export const appealPoint = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'appeal-points',
  http,
  index
}

export const industries = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'industries',
  http,
  index
}

export const industryCategory = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'industry-categories',
  http,
  index
}

export const country = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'countries',
  http,
  index,
  simpleSearch
}

export const japanRegion = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'japan-regions',
  http,
  index
}

export const language = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'languages',
  http,
  index
}

export const languageScoreLevel = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'language-score-levels',
  http,
  index
}

export const city = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'cities',
  http,
  index
}

export const channel = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'channels',
  http,
  index
}

export const companySizes = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'company-sizes',
  http,
  index
}

export const currency = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'currencies',
  http,
  index
}

export const dialingCode = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'dialing-codes',
  http,
  index
}

export const educationalLevel = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'educational-levels',
  http,
  index
}

export const deactivateReason = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'deactivate-reasons',
  http,
  index
}

export const emailNotification = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'cs-email-notifications',
  http,
  index
}

export const employmentType = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'employment-types',
  http,
  index
}

export const incomeRange = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'income-ranges',
  http,
  index
}

export const japaneseLanguageExperience = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'japanese-language-experiences',
  http,
  index
}

export const japanPrefecture = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'japan-prefectures',
  http,
  index
}

export const jobPosition = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'job-positions',
  http,
  index
}

export const jobPositionCategory = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'job-position-categories',
  http,
  index
}

export const languageCertificate = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'language-certificates',
  http,
  index
}

export const jobSearchStatus = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'job-search-statuses',
  http,
  index
}

export const nationality = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'nationalities',
  http,
  index
}

export const visaStatus = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'visa-statuses',
  http,
  index
}

export const workPermission = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'work-permissions',
  http,
  index
}

export const workingStatus = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'working-statuses',
  http,
  index
}

export const writingLevel = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'writing-levels',
  http,
  index
}

export const yoe = {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v2/masters`,
  url: 'yoe-ranges',
  http,
  index
}